import { calculateVisibleFieldProgress } from './formVisibleProgress';

/**
 * Paint panel header progress badges (e.g. 2/8) — same look as user portal.
 * Mutates DOM only; does not remount Form.io.
 */
export function updateFormioPanelBadges(formInstance, panelProgress) {
  if (!formInstance || typeof formInstance.everyComponent !== 'function') return;
  try {
    formInstance.everyComponent((compInstance) => {
      const schema = compInstance.component || {};
      const isPanel = schema.type === 'panel' || schema.type === 'fieldset';
      if (!isPanel || !schema.key) return;

      const progress = panelProgress?.[schema.key];
      if (!progress || !progress.total) return;

      const { percentage, filled, total } = progress;
      const badgeText = `${filled}/${total}`;
      const badgeClass = percentage === 100 ? 'badge-complete' : 'badge-progress';
      const badgeColor = percentage === 100 ? '#198754' : '#C9932E';

      const headerElement =
        compInstance.element &&
        (compInstance.element.querySelector('.card-header') ||
          compInstance.element.querySelector('.panel-heading') ||
          compInstance.element.querySelector('legend'));

      if (!headerElement) return;

      headerElement.querySelectorAll('.formio-progress-badge').forEach((n) => n.remove());

      const badgeEl = document.createElement('span');
      badgeEl.textContent = badgeText;
      badgeEl.className = `formio-progress-badge ${badgeClass}`;
      badgeEl.setAttribute('aria-hidden', 'true');
      badgeEl.style.setProperty('--progress', `${percentage}%`);
      badgeEl.style.setProperty('--progress-color', badgeColor);
      headerElement.appendChild(badgeEl);
    });
  } catch (err) {
    console.warn('updateFormioPanelBadges error', err);
  }
}

/** Compute panel progress from form data + schema, then paint badges. */
export function refreshFormioPanelBadges(formInstance, data, components) {
  if (!formInstance || !Array.isArray(components)) return null;
  const result = calculateVisibleFieldProgress(data || {}, components, formInstance);
  updateFormioPanelBadges(formInstance, result.byPanel || {});
  return result;
}
